import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Pages
import LandingPage from "./Pages/LandingPage";
import LoginPage from "./Pages/LoginPage";
import HomePage from "./Pages/HomePage";
import ClientsPage from "./Pages/ClientsPage";
import ProductsPage from "./Pages/ProductsPage";
import SalesPage from "./Pages/SalesPage";
import PaymentsPage from "./Pages/PaymentsPage";
import ClientLedgerPage from "./Pages/ClientLedgerPage";
import LedgerView from "./Pages/LedgerView";
import Dashboard from "./Pages/Dashboard";
import Navbar from "./Navbar";
import DeliveryPage from "./Pages/DeliveryPage";
import AccountingPage from "./Pages/AccountingPage";
import ProductionRuns from "./Pages/ProductionRuns";
import StockManagement from "./Pages/StockManagement";
import AdvancePaymentsPage from "./Pages/AdvancePaymentsPage";
import AdminUserManager from "./Pages/AdminUserManager";

// 🔑 NEW PAGES (ADDED)
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/ResetPasswordPage";

// Components
import Footer from "./Footer";

function App() {
  useTranslation(); // initialize i18n

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow bg-beige text-navy">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/products" element={<ProductsPage />} />
            {/* ❌ DEPRECATED - Use /delivery for sales, /accounting for payments */}
            {/* <Route path="/sales" element={<SalesPage />} /> */}
            {/* <Route path="/payments" element={<PaymentsPage />} /> */}
            <Route path="/ledger" element={<LedgerView />} />
            <Route path="/ledger/client" element={<ClientLedgerPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/delivery" element={<DeliveryPage />} />
            <Route path="/accounting" element={<AccountingPage />} />
            <Route path="/production" element={<ProductionRuns />} />
            <Route path="/stock-management" element={<StockManagement />} />
            <Route path="/advances" element={<AdvancePaymentsPage />} />
            <Route path="/admin/users" element={<AdminUserManager />} />
            
            {/* 🔑 NEW ROUTES (ADDED) */}
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;